/**
 * Spoken name + hover tooltip for an icon-only control. Tamagui's Button type
 * has no `title`, but a spread is exempt from excess-prop checks and the DOM
 * attribute is forwarded on web.
 */
export const iconLabel = (label: string) => ({ "aria-label": label, title: label });

/** Hover tooltip for a visible label that may be ellipsized; no aria-label, the text is the name. */
export const tooltip = (text: string) => ({ title: text });
